import React, { Component } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class Introduce extends Component {
    render() {
      const style = {
          done: {
            height: "430px",
            paddingTop: "60px",
            borderTop: 'solid 1px #ddd'
          },
          error: {
            height: "430px",
            paddingTop: "60px",
            borderBottom: 'solid 1px #ddd'
          }
      }
      const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 600,
        autoplaySpeed: 10000,
        arrows: false,
        fade: true,
        cssEase: 'linear',
        swipe: false
      };
      let {T, status} = this.props

      return (
        <div style={style[status]}>
          <div className="slider-box">
              <div className="left-line"></div>
              <T.text tag="h2" text={"introduce-blok.title"}/>
              <Slider {...settings}>
                <div className="slide">
                    <T.text tag="p" text={"introduce-blok.slide-1"}/>
                </div>
                <div className="slide">
                    <T.text tag="p" text={"introduce-blok.slide-2"}/>
                </div>
                <div className="slide">
                    <T.text tag="p" text={"introduce-blok.slide-3"}/>
                </div>
                <div className="slide">
                    <T.text tag="p" text={"introduce-blok.slide-4"}/>
                </div>
                <div className="slide">
                <T.text tag="p" text={"introduce-blok.slide-5"}/>
                </div>
              </Slider>
              <div className="right-line"></div>
          </div>
        </div>
      );
    }
  }




// WEBPACK FOOTER //
// ./src/components/layout/introduce.js